export default "textarea {\n  padding: 20px;\n}";